import React from "react";

interface DownloadButtonProps {
  onClick: () => void;
  title?: string;
  className?: string;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
  onClick,
  title = "Download Data",
  className = "",
}) => (
  <button
    onClick={onClick}
    title={title}
    className={[
      "flex items-center justify-center",
      "h-8 w-8 shrink-0",
      "bg-[#fff4ed] hover:bg-[#ff7c04]",
      "border border-[#ff7c04]",
      "text-[#ff7c04] hover:text-white",
      "rounded-full shadow-sm",
      "transition-colors duration-200",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  </button>
);

export default DownloadButton;
